import {crud} from 'app/lib/action';
import {VISITS} from '../constants/actionTypes';

export default crud(VISITS);